import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import cardStyles from '../../../card.module.css';
import styles from './aboutCard.module.css';

const AboutCard = () => (
  <div className={`${cardStyles.card}`}>
    <div className={`${styles.cardBody} ${cardStyles.cardBody}`}>
      <div className={`${styles.sectionHeader}`}>
          So who are we?
      </div>
      <div className={`${styles.sectionContent}`}>
        <p>
              Now that we&apos;ve established that we are twins, lets move on to
              what makes us... well... us!
            For one thing, we&apos;ve been
            in the same schools, the same colleges and now we&apos;re working in the same place!
            We also wear matching clothes everyday! (yup, we really embrace our twin-ness!).
        </p>
        <p>
              We&apos;re software engineers, web developers, gamers, hobbyist game developers,
              VR enthusiasts, and we dabble a bit in sketching, writing and poetry
              but before all that, <strong><em>we&apos;re brothers.</em></strong>
        </p>
        <p>
            We have a lot of similar interests, including, (as you might have guessed)
            Virtual Reality.(VR capable website: coming soon!).
            While you&apos;re here, be sure to scroll down and read a little more about each of us,
            check out some of the stuff we&apos;ve been working on, and browse through some of our
            thoughts and ideas that span a variety of topics.
        </p>
        <p>
            Don&apos;t leave without saying hello!  You can find either one of us on Facebook!
        </p>
        <p>
            Or on LinkedIn if you want to be all formal.
        </p>
      </div>
    </div>
  </div>
);


export default AboutCard;



// WEBPACK FOOTER //
// ./src/pageComponents/home/components/aboutCard/index.jsx